module.exports = __webpack_public_path__ + "static/media/pic22@3x.f2ad1c2b.png";